import React, { useEffect, useState } from "react";
import { Input, Form, Button, Slider, Select, Tooltip, Icon, notification } from "antd";
import { UploadOutlined, CopyOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { onboardVessel, updateOnboardVessel } from "../../features/Onboarding/OnboardingSlice";
import { fetchVesselDetailsTable, fetchPoolingMetrics } from "../../features/VesselDetails/VesselDetailsSlice";
import { rgb, values } from "pdf-lib";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import ClipboardJS from 'clipboard';

const { Option } = Select;
const OnBoardingForm = ({ type, rowData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const currentYear = new Date().getFullYear();
  const [prevPenalty, setPrevPenalty] = useState(null);

  const copyToClipboard = (text) => {
    // Create a temporary button for Clipboard.js to bind
    const tempButton = document.createElement('button');
    tempButton.style.opacity = '0'; // Hide the button
    tempButton.style.position = 'fixed'; // Prevent UI shift
    document.body.appendChild(tempButton);

    // Initialize Clipboard.js
    const clipboard = new ClipboardJS(tempButton, {
      text: () => text,
    });

    clipboard.on('success', () => {
      notification.success({
        message: 'Copied',
        description: 'The content has been copied to clipboard.',
      });
      clipboard.destroy();
      document.body.removeChild(tempButton);
    });

    clipboard.on('error', () => {
      notification.error({
        message: 'Copy failed',
        description: 'Failed to copy the content.',
      });
      clipboard.destroy();
      document.body.removeChild(tempButton);
    });

    // Programmatically trigger a click to activate Clipboard.js
    tempButton.click();
  };


  const [vesselName, setVesselName] = useState(rowData ? rowData?.vessel_name : "");
  const [selectedFile, setSelectedFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [natureerrorMessage, setNatureerrorMessage] = useState("");
  const [binaryData, setBinaryData] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileUrl, setFileUrl] = useState("");
  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  const [isOnboardedFromOtherPage, setIsOnboardedFromOtherPage] = useState(false);

  useEffect(() => {
    if (type != "edit" && type != "view" && document.referrer) {
      setIsOnboardedFromOtherPage(true);
    }

  }, [location]);



  useEffect(() => {
    if (isOnboardedFromOtherPage) {

      handleReset();
    }
  }, [isOnboardedFromOtherPage]);

  const sanitizeValue = (value, fallback) => {
    return value === undefined || value === "undefined" ? fallback : value;
  };

  const sanitizeNumValue = (value, fallback) => {
    return value === undefined || value === "undefined" || isNaN(value) ? fallback : value;
  };


  const [vesselData, setVesselData] = useState({
    requested_vessel_type: sanitizeValue(rowData?.requested_vessel_type, ""),
    year: sanitizeValue(rowData?.year, currentYear),
    imo_number: sanitizeValue(rowData?.imo_number, ""),
    vessel_name: sanitizeValue(rowData?.vessel_name, ""),
    ghg_intensity: sanitizeValue(rowData?.ghg_intensity, ""),
    compliance_balance: sanitizeNumValue(Math.abs(parseFloat(rowData?.compliance_balance)), null),
    penalty: sanitizeValue(rowData?.penalty, ""),
    expected_price_lv: sanitizeValue(rowData?.expected_price_lv, 0),
    expected_price_uv: sanitizeValue(rowData?.expected_price_uv, 640),
    verified_report_statement_url: sanitizeValue(rowData?.verified_report_statement_url, ""),
    cb_wants_to_sell: sanitizeNumValue(Math.abs(parseFloat(rowData?.cb_wants_to_sell)), null),
    pic__name: sanitizeValue(rowData?.pic__name, ""),
    pic__email: sanitizeValue(rowData?.pic__email, ""),
    pic__phone: sanitizeValue(rowData?.pic__phone, ""),
    pic__address: sanitizeValue(rowData?.pic__address, ""),
    pic__company_name: sanitizeValue(rowData?.pic__company_name, ""),
    broker_percentage: sanitizeValue(rowData?.broker_percentage, ""),
    wish_to_add_more_surplus_or_deficit: sanitizeValue(rowData?.wish_to_add_more_surplus_or_deficit, ""),
  });

  useEffect(() => {
    form.setFieldsValue({
      year: vesselData.year ? vesselData.year : currentYear,
      expected_price_lv: vesselData.expected_price_lv,
      expected_price_uv: vesselData.expected_price_uv,  // Set initial value of the year field
    });
  }, [vesselData.year, vesselData.expected_price_lv, vesselData.expected_price_uv, form]);


  const [selectedOptions, setSelectedOptions] = useState({
    option1: false,
    option2: false,
  });

  useEffect(() => {
    // Set the selected option based on vesseldata.wish_to_add_more_surplus_or_deficit
    if (type == "view" || type == "edit") {
      if (vesselData.wish_to_add_more_surplus_or_deficit) {
        setSelectedOptions({
          option1: true, // YES is selected if true
          option2: false,
        });
      }
      else {
        setSelectedOptions({
          option1: false, // YES is selected if true
          option2: true,
        });
      }

    } else {
      setSelectedOptions({
        option1: false,
        option2: false, // No is selected if false
      });
    }
  }, [vesselData.wish_to_add_more_surplus_or_deficit]);




  const [selectedOptionsStatus, setSelectedOptionsStatus] = useState(() => {
    if (type === "view" || type === "edit") {

      return {
        option1: vesselData?.compliance_balance >= 0,
        option2: vesselData?.compliance_balance < 0,
      };
    }
    return {
      option1: false,
      option2: false,
    };
  });

  useEffect(() => {
    // console.log("my type status", selectedOptionsStatus)
  }, [selectedOptionsStatus])

  const [formValidationStatus, setFormValidationStatus] = useState({
    imo_number: true,
    vessel_name: true,
    penalty: true,
    compliance_balance: true,
    ghg_intensity: true,
    pic__email: true,
    pic__phone: true,
    pic__address: true,
    pic__company_name: true,
    cb_wants_to_sell: true,
    broker_percentage: true,
    // initialize other fields here
  });


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      setSelectedFile(null);
      setErrorMessage("Please upload a file!");
      setFormValidationStatus((prevStatus) => ({
        ...prevStatus,
        verified_report_statement_url: false, // No file uploaded
      }));
      return;
    }

    // Check if the file size is greater than 1 MB
    if (file.size > 5 * 1024 * 1024) { // 1 MB limit
      setErrorMessage("File size should not exceed 5 MB.");
      setSelectedFile(null); // Clear selected file
      setFormValidationStatus((prevStatus) => ({
        ...prevStatus,
        verified_report_statement_url: false, // Invalid file size
      }));
      return;
    }

    // If file size is valid, proceed with file processing
    setSelectedFile(file);
    setErrorMessage(""); // Clear any previous error messages
    setFormValidationStatus((prevStatus) => ({
      ...prevStatus,
      verified_report_statement_url: true, // File is valid
    }));

    try {
      // Convert file to ArrayBuffer
      const arrayBuffer = await file.arrayBuffer();

      // Convert ArrayBuffer to Uint8Array (binary data)
      const binary = new Uint8Array(arrayBuffer);

      // Set binary data state
      setBinaryData(binary);
      setFileName(file.name);
      const fileUrl = URL.createObjectURL(file);
      setFileUrl(fileUrl);

    } catch (error) {
      console.error("File conversion error:", error);
    }
  };


  const handleSubmit = async () => {

    try {
      // Await validation to ensure all fields are validated before proceeding
      const validatedFields = await form.validateFields();

      // If options are not selected, set an error message
      if (!selectedOptionsStatus.option1 && !selectedOptionsStatus.option2) {
        setNatureerrorMessage("Need to select at least one option");
        return; // Prevent submission if no option is selected
      }

      // Prepare data payload
      const data = {
        year: vesselData.year,
        imo_number: vesselData.imo_number,
        vessel_name: vesselData.vessel_name,
        ghg_intensity: vesselData.ghg_intensity,
        compliance_balance: vesselData.compliance_balance,
        penalty: vesselData.penalty ? vesselData.penalty : 0,
        expected_price_lv: vesselData.expected_price_lv,
        expected_price_uv: vesselData.expected_price_uv,
        verified_emission_statement_file: selectedFile,
        broker_percentage: parseFloat(vesselData.broker_percentage),
        file_name: fileName,
        cb_wants_to_sell: vesselData?.cb_wants_to_sell || 0,
        wish_to_add_more_surplus_or_deficit: selectedOptions.option1,
        requested_vessel_type: selectedOptionsStatus.option1 ? "surplus" : (selectedOptionsStatus.option2 ? "deficit" : null),
        pic: {
          name: vesselData.pic__name,
          email: vesselData.pic__email,
          phone: vesselData.pic__phone,
          address: vesselData.pic__address,
          company_name: vesselData.pic__company_name,
        },
        ...(type === "edit" && { token_id: rowData.token_id }), // Include token_id for edit type
      };

      // Proceed based on form type (new or edit)
      if (type === "new") {
        // Dispatch the action to onboard the vessel
        const result = await dispatch(onboardVessel(data));

        // Check if the result indicates success
        if (result?.meta?.requestStatus === "fulfilled") {
          // Success notification
          notification.success({
            message: 'Success',
            description: `Vessel for ${vesselData.vessel_name} of IMO:${vesselData.imo_number} created successfully.`,
          });

          await dispatch(fetchPoolingMetrics());
          await dispatch(fetchVesselDetailsTable());
          navigate("/dashboard");

          // Close the notification after 8 seconds
          setTimeout(() => {
            notification.destroy(); // Close all notifications
          }, 8000);
        } else {
          notification.error({
            message: 'Error',
            description: `Failed to onboard vessel. Check Inputs. Make sure IMO Number is not Repeated`,
          });
          return;
        }
      } else if (type === "edit") {
        // Dispatch the action to update the onboard vessel
        const result = await dispatch(updateOnboardVessel(data));

        // Check if the result indicates success
        if (result?.meta?.requestStatus === "fulfilled") {
          notification.success({
            message: "Success",
            description: `Vessel for ${vesselData.vessel_name} of IMO:${vesselData.imo_number} updated successfully.`,
          });

          await dispatch(fetchPoolingMetrics());
          await dispatch(fetchVesselDetailsTable());
          navigate("/dashboard");

          setTimeout(() => {
            notification.destroy(); // Automatically destroy notification after 8 seconds
          }, 8000);

        } else {
          notification.error({
            message: 'Error',
            description: `Failed to onboard vessel. Check Inputs.`,
          });
          return;

        }
      }


    } catch (error) {
      // Handle form validation error (in case validateFields throws an error)
      console.error("Form validation failed", error);
      notification.error({
        message: 'Form Submission Error',
        description: 'Please fix the form errors before submitting.',
      });
    }
  };

  useEffect(() => {
    if (vesselData?.compliance_balance) {
      form.validateFields(["cb_wants_to_sell"]);

    }
  }, [selectedOptionsStatus])


  const validateComplianceBalanceForTrading = (_, value) => {
    const tradingBalance = Math.abs(Number(value));  // Always positive
    const complianceBalance = Math.abs(Number(type == "view" || type == "edit" ? rowData?.compliance_balance : rowData?.compliance_balance));

    // Check if the field is empty
    if (value === undefined || value === null || value === "") {
      return Promise.reject(
        // new Error("Compliance Balance for Trading is required!")
      );
    }


    return Promise.resolve();
  };

  useEffect(() => {
    if (vesselData.compliance_balance && vesselData.cb_wants_to_sell) {
      form.validateFields(["compliance_balance", "cb_wants_to_sell"]);

    }
  }, [vesselData.compliance_balance, vesselData.cb_wants_to_sell]);


  const handleInputChange = async (e) => {
    const { name, value } = e.target;

    const nonNumericFields = ["pic__name"];
    const numericFields = ["expected_price_lv", "expected_price_uv"];

    // Prevent numeric input for non-numeric fields
    if (nonNumericFields.includes(name) && /\d/.test(value)) {
      return;
    }


    // Handle changes to "cb_wants_to_sell" if option2 is selected
    // if (selectedOptionsStatus.option2 === true && name === "compliance_balance") {
    //   form.setFieldsValue({
    //     cb_wants_to_sell: value || vesselData.compliance_balance
    //   });
    //   setVesselData((prevData) => ({
    //     ...prevData,
    //     cb_wants_to_sell: value || prevData.compliance_balance,
    //   }));
    // }

    if (name === "penalty") {
      // Prevent backspace or input modification if option1 is selected
      if (name === "penalty") {
        if (selectedOptionsStatus.option2 === true && value == 0 && value !== "") {
          form.setFieldsValue({
            penalty: prevPenalty,
          });
          setVesselData((prevData) => ({
            ...prevData,
            penalty: prevPenalty,
          }));
          return;
        } else if (selectedOptionsStatus.option2 === true && value === "") {
          form.setFieldsValue({
            penalty: null,
          });
          setVesselData((prevData) => ({
            ...prevData,
            penalty: null,
          }));
          return;
        }

        form.setFieldsValue({
          penalty: value
        });
        setVesselData((prevData) => ({
          ...prevData,
          penalty: value,
        }));

        return;
      }
      else if (selectedOptionsStatus.option2 === true && value == 0 && value !== "") {
        form.setFieldsValue({
          penalty: prevPenalty,
        });
        setVesselData((prevData) => ({
          ...prevData,
          penalty: prevPenalty,
        }));
        return;

      } else if (selectedOptionsStatus.option2 === true && value === "") {
        form.setFieldsValue({
          penalty: null,
        });
        setVesselData((prevData) => ({
          ...prevData,
          penalty: null,
        }));
        return;

      }

      form.setFieldsValue({
        penalty: value
      });
      setVesselData((prevData) => ({
        ...prevData,
        penalty: value,
      }));


      return;
    }

    // Handle numeric fields
    const updatedValue = numericFields.includes(name)
      ? value === "" ? "" : Number(value)
      : value;

    if (numericFields.includes(name) && (updatedValue < 0 || updatedValue > 640)) {
      return;
    }

    // Validate related fields
    if (numericFields.includes(name)) {
      form.validateFields(["expected_price_lv", "expected_price_uv"]);
    }

    // Update vessel data and form fields
    form.setFieldsValue({
      [name]: updatedValue
    });
    setVesselData((prevData) => ({
      ...prevData,
      [name]: updatedValue,
    }));
  };

  useEffect(() => {
    if (!selectedOptionsStatus.option1 && !selectedOptionsStatus.option2 && vesselData?.compliance_balance) {
      // Execute the logic if both options are false
      setNatureerrorMessage("Need to select at least one option");
    }
  }, [vesselData?.compliance_balance])

  const handleSliderChange = (value) => {
    const [lower, upper] = value;

    // Ensure `expected_price_lv` is not greater than `expected_price_uv`
    if (lower <= upper) {
      setVesselData((prevState) => ({
        ...prevState,
        expected_price_lv: lower,
        expected_price_uv: upper,
      }));
    } else {
      // Optionally reset values or set them to default when lower > upper
      setVesselData((prevState) => ({
        ...prevState,
        expected_price_lv: prevState.expected_price_uv,
        expected_price_uv: prevState.expected_price_lv,
      }));
    }

    // Trigger re-render of input fields 
    form.setFieldsValue({
      expected_price_lv: lower,
      expected_price_uv: upper
    });
  };

  const handleCheckboxChange = (option) => {
    if (type == "view") {
      return;
    }
    // Update the state based on the option clicked
    setSelectedOptions((prev) => ({
      ...prev,
      // Toggle the clicked option and reset the other option
      [option]: !prev[option],
      ...(option === "option1" && { option2: false }), // Ensure only one option is selected
      ...(option === "option2" && { option1: false }), // Ensure only one option is selected
    }));
  };

  useEffect(() => {

    if (type == "view" || type == "edit") {
     
      if (type == "view" || type == "edit" && rowData?.compliance_balance >= 0) {
        setSelectedOptionsStatus({
          option1: true, // YES is selected if true
          option2: false,
        });
      }
      else {
        setSelectedOptionsStatus({
          option1: false, // YES is selected if true
          option2: true,
        });
      }

    } else {

    }
  }, [vesselData.compliance_balance]);


  const handleCheckboxChangeStatus = (option) => {
    if (type === "view") {
      return;
    }

    setSelectedOptionsStatus((prev) => {
      const updatedOptions = {
        ...prev,
        // Toggle the clicked option and reset the other option
        [option]: !prev[option],
        ...(option === "option1" && { option2: false }), // Ensure only one option is selected
        ...(option === "option2" && { option1: false }), // Ensure only one option is selected
      };

      // Update cb_wants_to_sell if option2 is selected
      // if (updatedOptions.option2 === true) {
      //   // Use form.setFieldValue to update the form field
      //   form.setFieldsValue({
      //     cb_wants_to_sell: vesselData.compliance_balance
      //   });
      //   setVesselData((prevData) => ({
      //     ...prevData,
      //     cb_wants_to_sell: vesselData.compliance_balance,
      //   }));
      // }

      // Update penalty field based on option1 selection
      setVesselData((prevData) => {
        if (updatedOptions.option1) {
          setPrevPenalty(prevData.penalty);
        } else {

        }

        const updatedPenalty = updatedOptions.option1 ? 0 : updatedOptions.option2 ? prevPenalty : prevData.penalty || null;
        // Use form.setFieldValue to update the form field
        form.setFieldsValue({
          penalty: updatedPenalty
        });
        return {
          ...prevData,
          penalty: updatedPenalty,
        };
      });

      return updatedOptions;
    });

    setNatureerrorMessage("");
  };


  const inputDisabledStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  };



  const handleReset = () => {
    form.resetFields();
    setNatureerrorMessage("");

    setSelectedOptions({ option1: false, option2: false });
    setSelectedOptionsStatus({ option1: false, option2: false });
    setVesselData({
      expected_price_lv: 0,
      expected_price_uv: 640,
      year: currentYear,
    });
  };

  const handleYearChange = (year) => {
    setVesselData((prevData) => ({
      ...prevData,
      year: year,
    }));
  };




  const generateYears = (currentYear) => {

    const years = [];
    for (let i = currentYear; i <= currentYear + 26; i++) {
      years.push(i);
    }
    return years;
  };


  return (
    <div className="onboarding-container">
      <Form
        form={form}
        name="vesselOnboarding"
        className="onboarding-form"
        layout="vertical"
        initialValues={
          type === "view" || type === "edit"
            ? {
              vessel_name: vesselData?.vessel_name,
              imo_number: vesselData?.imo_number,
              penalty: vesselData?.penalty,
              ghg_intensity: vesselData?.ghg_intensity,
              compliance_balance: vesselData?.compliance_balance,
              cb_wants_to_sell: vesselData?.cb_wants_to_sell,
              expected_price_lv: vesselData?.expected_price_lv,
              expected_price_uv: vesselData?.expected_price_uv,
              year: vesselData?.year ? vesselData.year : currentYear,
              pic__name: vesselData?.pic__name,
              pic__company_name: vesselData?.pic__company_name,
              pic__phone: vesselData?.pic__phone,
              pic__address: vesselData?.pic__address,
              pic__email: vesselData?.pic__email,
            }
            : {}
        }
      >

        {/* Dummy Input Fields Below Vessel Name */}
        <h6 className="headers-onboarding-parts heading">Vessel Details</h6>
        <div className="onboarding-input-group vessel-details">
          <Form.Item
            initialValues={{
              vessel_name: vesselData?.vessel_name,
            }}
            label={
              <span className="dummy-heading">
                Vessel Name <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="vessel_name"
            rules={[
              { required: false, message: "Vessel Name is required!" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("Vessel Name cannot be empty!")),
              },
            ]}
            hasFeedback
          >
            <div className="input-wrapper">
              <Input
                className="onboarding-input secondary-input"
                placeholder="Enter Value here"
                name="vessel_name"
                style={type === "view" ? inputDisabledStyle : {}}
                value={vesselData.vessel_name}
                onChange={handleInputChange}
                disabled={type == "view" ? true : false}
              />
            </div>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">IMO Number <span style={{ color: 'red' }}>*</span>
            </span>}
            initialValues={{
              imo_number: vesselData?.imo_number,
            }}
            name="imo_number"
            rules={[
              {
                // required: true,
                message: "IMO Number is required!",
              },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("IMO Number cannot be empty!")),
              },
              {
                pattern: /^[0-9]{7}$/,
                message: "IMO Number must be exactly 7 digits!",
              },
            ]}
            validateTrigger={['onBlur', 'onChange']}  // Trigger validation on both blur and change
            hasFeedback

          >
            <div className="input-wrapper">
              <Input
                className="onboarding-input secondary-input onboarding"
                placeholder="Enter Value here"
                name="imo_number"
                style={type === "view" ? inputDisabledStyle : {}}
                value={vesselData.imo_number}
                onChange={(e) => {
                  const value = e.target.value;
                  const isValid = /^[0-9]{7}$/.test(value);  // Validate 7 digits immediately

                  // Update input state
                  handleInputChange(e);

                  // Update form validation status
                  setFormValidationStatus((prevStatus) => ({
                    ...prevStatus,
                    imo_number: isValid,  // True if valid, false if not
                  }));
                }}
                onBlur={(e) => {
                  const value = e.target.value;
                  const isValid = /^[0-9]{7}$/.test(value);

                  // Final validation check when the field loses focus
                  setFormValidationStatus((prevStatus) => ({
                    ...prevStatus,
                    imo_number: isValid,
                  }));
                }}
                disabled={type == "view" || type == "edit" ? true : false}
                maxLength={7}  // Prevents typing more than 7 digits
                onKeyDown={(e) => {
                  const allowedKeys = /^[0-9]$/;
                  if (!allowedKeys.test(e.key) && e.key !== "Backspace") {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">Year</span>}
            name="year"
            initialValues={{
              year: vesselData.year ? vesselData.year : currentYear,
            }}
            style={{ flex: 1 }} // Ensure it adjusts with the layout
          >
            <Select
              className="onboarding-input-dropdown" // Match style with other inputs
              placeholder="Select Year"
              defaultValue={vesselData.year}
              style={type === "view" ? inputDisabledStyle : {}}
              disabled={type == "view" ? true : false}
              onChange={handleYearChange}
            >
              {generateYears(currentYear).map((year) => (
                <Option key={year} value={year}>
                  {year}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <div className="upload-section">
            <h4 className="upload-heading">
              Attach verified emission statements below
            </h4>
            <br />
            {type === "new" || type === "edit" ? (
              <div className="upload-container">
                <label htmlFor="file-upload" className="upload-label">
                  <UploadOutlined className="upload-icon" />
                  <span className="upload-text">
                    Upload (pdf ,doc ,docx ,txt)
                  </span>
                </label>
                <input
                  id="file-upload"
                  type="file"
                  accept=".pdf,.doc,.docx,.txt"
                  style={type === "view" ? { display: "none", ...inputDisabledStyle } : { display: "none" }}
                  name="verified_report_statement_url"
                  onChange={handleFileChange}
                />
                {/* Display error message if no file is selected or file size exceeds 1MB */}
                {formValidationStatus?.verified_report_statement_url === false && (
                  <span className="error-message" style={{ color: 'red' }}>
                    {`* ${errorMessage || "Please upload a valid file!"}`}
                  </span>
                )}
              </div>

            ) : ""
            }

            {selectedFile ?
              <div className='file-view'>
                <a
                  href={fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#678dff', textDecoration: 'none' }}
                >
                  View File
                </a>
              </div>
              :
              ""
            }

            {vesselData?.verified_report_statement_url && type == "edit" ?
              <div className='file-view'>
                <a
                  href={vesselData?.verified_report_statement_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#678dff', textDecoration: 'none' }}
                >
                  View Uploaded Report
                </a>
              </div>
              :
              ""
            }


          </div>
        </div>

        <h6 className="headers-onboarding-parts">Compliance Details</h6>
        <div className="onboarding-input-group compliance-details">

          <Form.Item
            label={
              <span className="dummy-heading">
                Compliance Balance <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="compliance_balance"
            rules={[
              {
                validator: (_, value) =>
                  value?.toString().trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("Compliance Balance cannot be empty!")),
              },
              {
                validator: (_, value) => {
                  if (
                    value &&
                    parseFloat(value) <= parseFloat(vesselData?.cb_wants_to_sell) - 1 &&
                    selectedOptionsStatus.option1
                  ) {
                    return Promise.reject(
                      new Error("Compliance Balance cannot be less than Compliance Balance for Trading.")
                    );
                  }
                  return Promise.resolve();
                },
              },
            ]}
            hasFeedback
          >
            <Input
              className="onboarding-input secondary-input compliance-balance-input"
              placeholder="Enter Value here"
              name="compliance_balance"
              value={vesselData?.compliance_balance}
              disabled={type === "view"}
              style={type === "view" ? inputDisabledStyle : {}}
              onChange={handleInputChange}
              onKeyDown={(e) => {
                const allowedKeys = /^[0-9]$/;
                if (!allowedKeys.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && !e.ctrlKey) {
                  e.preventDefault();
                }
              }}
              onPaste={(e) => {
                e.preventDefault();

                let pastedValue = e.clipboardData.getData("Text");
                pastedValue = pastedValue.replace(/[^0-9.]/g, "");

                if (pastedValue.includes(".")) {
                  pastedValue = pastedValue.split(".")[0];
                }

                const parsedValue = parseInt(pastedValue, 10);

                setVesselData((prevData) => {
                  const updatedData = {
                    ...prevData,
                    compliance_balance: isNaN(parsedValue) ? "" : parsedValue,
                  };

                  form.setFieldsValue({
                    compliance_balance: isNaN(parsedValue) ? "" : parsedValue,
                  });

                  return updatedData;
                });
              }}
              addonAfter={
                <span style={{ fontSize: "0.9em" }}>
                  gCO<sub style={{ fontSize: "0.8em", verticalAlign: "sub" }}>2</sub>e
                </span>
              }
            />
          </Form.Item>


          {["expected_price_lv", "expected_price_uv"].map((key) => (
            <Form.Item
              key={key}
              name={key}
              rules={[
                { required: false, message: "Price range is required!" },
                {
                  validator(_, value) {
                    const expectedPriceLv = Number(form.getFieldValue("expected_price_lv") ?? 0);
                    const expectedPriceUv = Number(form.getFieldValue("expected_price_uv") ?? 640);

                    if (key === "expected_price_lv") {
                      if (value < 0) {
                        return Promise.reject("Value must be more than 0");
                      }
                      if (value > expectedPriceUv) {
                        return Promise.reject("Lower price must be less than upper price");
                      }
                    }

                    if (key === "expected_price_uv") {
                      if (value > 640) {
                        return Promise.reject("Value must be less than or equal to 640");
                      }
                      if (value < expectedPriceLv) {
                        return Promise.reject("Upper price must be more than lower price");
                      }
                    }

                    return Promise.resolve();
                  },
                },
              ]}
              validateTrigger="onChange"
              initialValue={vesselData?.[key] ?? (key === "expected_price_lv" ? 0 : 640)}
              label={
                key === "expected_price_lv"
                  ? <span className="dummy-heading">Expected Lower Price <span style={{ color: 'red' }}>*</span></span>
                  : <span className="dummy-heading">Expected Upper Price <span style={{ color: 'red' }}>*</span></span>
              }
            >
              <Input
                type="number"
                name={key}
                className="onboarding-input secondary-input"
                addonAfter={<>€/MT CO<sub>2</sub>e</>}
                min={0}
                max={640}
                style={type === "view" ? inputDisabledStyle : {}}
                disabled={type === "view"}
                onChange={handleInputChange}
              />
            </Form.Item>
          ))}
          <div className="compliance-balance-nature">
            <span className="dummy-heading compliance-heading">
              Nature of Compliance Balance
              <span style={{
                display: 'inline-flex',
                justifyContent: 'center',
                alignItems: 'center',
                color: 'rgba(255, 0, 0, 1)',
                fontWeight: 100,
              }}>*</span>
            </span>
            <div className="checkbox-group">
              {/* Surplus Option */}
              <div
                className={`custom-checkbox-container ${selectedOptionsStatus.option1 ? "checked" : ""
                  }`}
                onClick={() => handleCheckboxChangeStatus("option1")}
              >
                <div className="custom-checkbox">
                  {selectedOptionsStatus.option1 && (
                    <span className="checkbox-tick">✔</span>
                  )}
                </div>
                <span className="checkbox-label">Surplus</span>
              </div>

              {/* Deficit Option */}
              <div
                className={`custom-checkbox-container ${selectedOptionsStatus.option2 ? "checked" : ""
                  }`}
                onClick={() => handleCheckboxChangeStatus("option2")}
              >
                <div className="custom-checkbox">
                  {selectedOptionsStatus.option2 && (
                    <span className="checkbox-tick">✔</span>
                  )}
                </div>
                <span className="checkbox-label">Deficit</span>
              </div>
            </div>
            {/* <span style={{color:"red"}}>{natureerrorMessage}</span> */}
          </div>
        </div>

        <div className="onboarding-input-group compliance-details">

          <Form.Item
            label={
              <span className="dummy-heading">
                Compliance Balance for Trading <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="cb_wants_to_sell"
            rules={[
              {
                validator: (_, value) => {
                  if (value === undefined || value === null || value.toString().trim() === "") {
                    return Promise.reject(new Error("Compliance Balance for Trading is required!"));
                  }

                  const numericValue = parseFloat(value);
                  const complianceBalance = parseFloat(vesselData?.compliance_balance);

                  if (selectedOptionsStatus.option1 && numericValue > complianceBalance) {
                    return Promise.reject(
                      new Error("Compliance Balance for Trading cannot be greater than Compliance Balance.")
                    );
                  }

                  if (selectedOptionsStatus.option2 && numericValue < complianceBalance) {
                    return Promise.reject(
                      new Error("For Deficit, this value should be greater than or equal to Compliance Balance!")
                    );
                  }

                  return Promise.resolve();
                }
              }
            ]}
            validateTrigger="onChange"
            hasFeedback
          >
            <Tooltip
              title={
                !vesselData?.compliance_balance || (!selectedOptionsStatus.option1 && !selectedOptionsStatus.option2)
                  ? 'First enter Compliance Balance and Select Nature of Compliance'
                  : ''
              }
            >
              <div className="input-wrapper">
                <Input
                  className="onboarding-input secondary-input"
                  placeholder="Enter Value here"
                  name="cb_wants_to_sell"
                  value={vesselData.cb_wants_to_sell}
                  style={type === "view" ? inputDisabledStyle : {}}
                  onChange={handleInputChange}
                  disabled={type === "view" || (!vesselData?.compliance_balance || (!selectedOptionsStatus.option1 && !selectedOptionsStatus.option2))}
                  onKeyDown={(e) => {
                    const allowedKeys = /^[0-9]$/;
                    if (!allowedKeys.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && !e.ctrlKey) {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();

                    let pastedValue = e.clipboardData.getData("Text");
                    pastedValue = pastedValue.replace(/[^0-9.]/g, "");
                    if (pastedValue.includes(".")) {
                      pastedValue = pastedValue.split(".")[0];
                    }

                    const parsedValue = parseInt(pastedValue, 10);

                    setVesselData((prevData) => {
                      const updatedData = {
                        ...prevData,
                        cb_wants_to_sell: isNaN(parsedValue) ? "" : parsedValue,
                      };

                      form.setFieldsValue({
                        cb_wants_to_sell: isNaN(parsedValue) ? "" : parsedValue,
                      });

                      return updatedData;
                    });
                  }}
                  addonAfter={
                    <span style={{ fontSize: "0.9em" }}>
                      gCO<sub style={{ fontSize: "0.8em", verticalAlign: "sub" }}>2</sub>e
                    </span>
                  }
                />
              </div>
            </Tooltip>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">FEUM Penalty</span>}
            initialValues={{
              penalty: vesselData?.penalty,
            }}
            name="penalty"
          // rules={[{ required: false, message: "Penalty is required!" }]}
          // hasFeedback={vesselData?.penalty}
          >
            <div className="input-wrapper">
              <Input
                className="onboarding-input secondary-input penalty"
                placeholder="Enter Value here"
                value={vesselData.penalty}
                name="penalty"
                prefix={<span style={{ color: "black" }}>€</span>}
                step={0.01}
                style={type === "view" ? inputDisabledStyle : {}}
                onChange={handleInputChange}
                disabled={type === "view"}
                formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                precision={2}
                onInput={(event) => {
                  const { value } = event.target;
                  const regex = /^\d+(\.\d{0,2})?$/;
                  if (!regex.test(value) && value !== '') {
                    event.target.value = value.slice(0, -1); // Remove the last character
                  }
                }}

              />
            </div>
          </Form.Item>


          <Form.Item
            label={<span className="dummy-heading">GHG Intensity <span style={{ color: 'red' }}>*</span></span>}
            name="ghg_intensity"
            rules={[
              {
                validator(_, value) {
                  if (value === undefined || value === "") {
                    return Promise.reject(new Error("GHG Intensity cannot be empty!"));
                  }
                  else {
                    return Promise.resolve();
                  }
                }
              }
            ]}
            hasFeedback

          >
            <div className="input-wrapper">
              <Input
                className="onboarding-input secondary-input"
                placeholder="Enter Value here"
                value={vesselData?.ghg_intensity || ""}
                name="ghg_intensity"
                style={type === "view" ? inputDisabledStyle : {}}
                disabled={type === "view" ? true : false}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value.match(/^-\d*(\.\d{0,2})?$/) || value.match(/^\d*(\.\d{0,2})?$/)) {
                    setVesselData(prevData => ({
                      ...prevData,
                      ghg_intensity: value
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  const allowedKeys = /^[0-9.-]$/;
                  const currentValue = e.target.value;
                  if (
                    !allowedKeys.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "." ||
                    (currentValue.includes(".") && e.key === ".")
                  ) {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </Form.Item>

        </div>


        <h6 className="headers-onboarding-parts">PIC - Person in Charge of Pooling Decisions</h6>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            color: "#888",
            marginBlock: "1vh",
            fontStyle: "italic",
            fontSize: `${window.innerHeight <= 786 ? "1.8vh" : "1.5vh"}`,
          }}
        >
          {/* <h6>PIC - Person in Charge of Pooling Decisions</h6> */}
        </div>
        <div className="onboarding-input-group pic-details">
          <Form.Item
            label={<span className="dummy-heading">PIC Name <span style={{ color: 'red' }}>*</span></span>}
            initialValues={{
              pic__name: vesselData?.pic__name,
            }}
            name="pic__name"
            rules={[
              { required: false, message: "Please enter PIC Name!" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("PIC Name cannot be empty!")),
              },
            ]}
          >
            <div className="input-wrapper">

              <Input
                className="onboarding-input secondary-input"
                placeholder="Enter Value here"
                name="pic__name"
                defaultValue={vesselData?.pic__name}
                style={type === "view" ? inputDisabledStyle : {}}
                disabled={type == "view" ? true : false}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                onInput={(e) => {
                  // Remove special characters from the input value as the user types
                  e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                }}
              />
            </div>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">PIC's Company Name <span style={{ color: 'red' }}>*</span></span>}
            name="pic__company_name"
            initialValues={{
              pic__company_name: vesselData?.pic__company_name,
            }}
            rules={[
              { required: false, message: "Please enter PIC Company Name!" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("PIC Company Name cannot be empty!")),
              },
              // Optional validation
            ]}
          >
            <div className="input-wrapper">

              <Input
                className="onboarding-input secondary-input"
                placeholder="Enter Value here"
                name="pic__company_name"
                style={type === "view" ? inputDisabledStyle : {}}
                defaultValue={vesselData.pic__company_name}
                disabled={type == "view" ? true : false}
                onChange={(e) => {
                  handleInputChange(e);
                }}
              />
            </div>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">PIC's Email <span style={{ color: 'red' }}>*</span></span>}
            name="pic__email"
            initialValues={{
              pic__email: vesselData?.pic__email,
            }}
            rules={[
              // { required: false, message: "Email is required!" },
              {
                validator: (_, value) =>
                  value && value.trim()
                    ? Promise.resolve()
                    : Promise.reject(new Error("PIC Email cannot be empty!")),
              },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          // hasFeedback

          >
            <div className="input-wrapper">
              <Input
                className="onboarding-input secondary-input"
                placeholder="Enter Value here"
                style={type === "view" ? inputDisabledStyle : {}}
                disabled={type == "view" ? true : false}
                value={vesselData.pic__email}
                name="pic__email"
                onChange={(e) => {
                  handleInputChange(e);
                }}
              />
            </div>
          </Form.Item>
          <Form.Item
            label={<span className="dummy-heading">PIC's Mobile No. <span style={{ color: 'red' }}>*</span></span>}
            name="pic__phone"
            initialValues={{
              pic__phone: vesselData?.pic__phone,
            }}
            rules={[
              { required: false, message: "Mobile number is required!" },
              {
                pattern: /^[0-9]+$/,
                message: "Only numbers are allowed",
              },
            ]}
          >
            <PhoneInput
              country={"us"}
              value={vesselData.pic__phone} // Binds the phone input with the value
              disabled={type === "view"}
              className="phone_input"
              name="pic__phone"
              onChange={(value) => {
                if (type !== "view") { // Prevent onChange in "view" mode
                  setVesselData({ ...vesselData, pic__phone: value });
                }
                form.setFieldsValue({ pic__phone: value });
              }}
              inputStyle={
                type === "view" ? inputDisabledStyle :
                  {
                    backgroundColor: "#FFFFFF",
                    borderRadius: "8px !important",
                    height: "33px",
                    border: "1px solid #ccc",
                    width: "100%", // Ensure input takes full width
                  }}
              buttonClass="country-flag-dropdown"
              placeholder="Enter mobile number"
              specialLabel={false}
              searchPlaceholder="Search for country..."
            />
          </Form.Item>
        </div>
        <div className="onboarding-input-group-business">
          <Form.Item
            label={<span className="dummy-heading">Business Address</span>}
            name="pic__address"
            initialValues={{
              pic__address: vesselData?.pic__address,
            }}
            rules={[
              // { required: true, message: "Please enter your address!" },
              { max: 500, message: "Address cannot exceed 500 characters!" }, // Optional validation
            ]}
          >
            <Input
              className="onboarding-input-secondary-input-last"
              placeholder="Enter Address here"
              disabled={type == "view" ? true : false}
              name="pic__address"
              style={type === "view" ? inputDisabledStyle : {}}
              defaultValue={vesselData.pic__address}
              onChange={(e) => handleInputChange(e)}
              rows={4} // Adjust height based on rows
            />
          </Form.Item>
        </div>
        {type == "view" ? "" :
          <div className="form-buttons-container-bottom">
            <Button
              type="primary"
              className="save-vessel-button"
              htmlType="submit"
              onClick={handleSubmit}
            >
              {type == "new"
                ? "Save This Vessel"
                : type == "edit"
                  ? "Update This Vessel"
                  : ""}
            </Button>
            {type == "edit" ?
              " "
              :
              <Button
                type="button"
                className="reset-vessel-button"
                onClick={handleReset}
              >
                Reset Inputs
              </Button>
            }
          </div>}
      </Form>
    </div>
  );
};

export default OnBoardingForm;
